import mime from "mime"

export function getContentType(extension) {
  return mime.getType(extension)
}
